module.exports = __webpack_public_path__ + "static/media/TheSans_LP_300_Light.2bb11fd4.woff";